import dayjs from "dayjs";

export const getPriorityColor = (priority: string) => {
    switch (priority) {
        case 'urgent': return 'error';
        case 'high': return 'warning';
        case 'normal': return 'primary';
        case 'low': return 'default';
        default: return 'default';
    }
};

export const getPriorityLabel = (priority: string) => {
    switch (priority) {
        case 'urgent': return 'Urgent';
        case 'high': return 'High';
        case 'normal': return 'Normal';
        case 'low': return 'Low';
        default: return 'Normal';
    }
};

export const getDeliveryStatusColor = (status: string) => {
    switch (status) {
        case 'delivered': return 'success';
        case 'sent': return 'info';
        case 'pending': return 'warning';
        case 'failed': return 'error';
        case 'bounced': return 'error';
        default: return 'default';
    }
};

export const formatRelativeTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)}d ago`;

    return date.toLocaleDateString();
};

export const formatFullDate = (dateString: string, f = 'long') => {
    if (f === 'short') {
        return new Date(dateString).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    }
    return dayjs(dateString).format('YYYY-MM-DD HH:mm');
};

export const truncateMessage = (message: string, maxLength: number = 100) => {
    if (message.length <= maxLength) return message;
    return message.substring(0, maxLength) + '...';
};

export const formatNotificationTypeLabel = (type: string) =>
    type.split('-').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

export const getChannelLabel = (channel: string) => {
    switch (channel) {
        case 'dashboard': return 'Dashboard';
        case 'email': return 'Email';
        case 'sms': return 'SMS';
        default: return channel;
    }
};

/** True when the notification has been seen/opened (seen_at is set). */
export const isNotificationSeen = (notification: { seen_at?: string | null }) =>
    Boolean(notification.seen_at);

export const getNotificationStatusLabel = (
    channel: string,
    seenAt: string | null | undefined,
    deliveryStatus: string,
) => (channel === 'dashboard' ? (seenAt ? 'Seen' : 'Unread') : deliveryStatus);

export const getNotificationStatusColor = (
    channel: string,
    seenAt: string | null | undefined,
    deliveryStatus: string,
) => {
    if (channel === 'dashboard') {
        return seenAt ? 'default' : 'primary';
    }
    return getDeliveryStatusColor(deliveryStatus);
};

export const formatNotificationTimestamp = (dateString: string) => {
    const relative = formatRelativeTime(dateString);
    const absolute = formatFullDate(dateString);
    return relative === absolute ? absolute : `${relative} · ${absolute}`;
};
